import { useProject } from '../../project-hooks/useProject';
import { ContentTitle, Title } from '../../../components/typography/Heading';
import { formatMoneyKroner, formatNumber, pluralize } from '../../../utils';
import RemainingTime from '../../remaining-time/RemainingTime';
import ScreenReaderOnly from '../../../accessibility/ScreenReaderOnly';
import ProjectOwnerAndReceiver from '../project-owner-and-receiver/ProjectOwnerAndReceiver';
import ProjectProgress from '../../../components/project-progress/ProjectProgress';
import CollectedAmountAnimated from '../../collected-amount-animated/CollectedAmountAnimated';
import ThemeContainer from '../../../components/theme-container/ThemeContainer';
import { THEMES } from '../../../utils/cms-utils';
import ProjectSupportButtons from '../project-support-buttons/ProjectSupportButtons';
import IsLive from '../is-live/IsLive';
import { NumberOfRecentTransactions } from '../number-of-recent-transactions/NumberOfRecentTransactions';
import Image from '../../../components/image/Image';
import styles from './ProjectInfoBox.module.less';
import { isBirthdayProject } from '../../project-model';
import { DONOR_TEXT_KEY, DONORS_TEXT_KEY } from '../../i18n/project-i18n-model';
import { useI18nTexts } from '../../i18n/useI18nTexts';

const ProjectInfoBox = ({ className = '', showSupportButtons = true, projectShareModalRef }) => {
    const project = useProject();
    const birthdayProject = isBirthdayProject(project);
    const texts = useI18nTexts([DONORS_TEXT_KEY, DONOR_TEXT_KEY]);
    return (
        <div className={className}>
            <ThemeContainer mainColor={THEMES.SAND70} className={styles.projectInfoBox}>
                <div className={styles.waveSection}>
                    <ThemeContainer mainColor={THEMES.DARKBLUE} className={styles.titleAndCollected}>
                        <IsLive />
                        <ContentTitle
                            tag={'h1'}
                            className={`${styles.projectTitle} ${project?.title?.length > 80 ? styles.long : ''}`}
                        >
                            {project.title}
                        </ContentTitle>
                        <div>
                            <ContentTitle tag={'h2'} className={styles.collectedAmount}>
                                <span aria-hidden={true}>
                                    <CollectedAmountAnimated />
                                    <span className={styles.currency}> kr</span>
                                </span>
                                <ScreenReaderOnly tag={'span'}>
                                    {formatMoneyKroner(project?.collected_amount ?? 0)} innsamlet
                                </ScreenReaderOnly>
                            </ContentTitle>

                            <Title tag={'div'} className={styles.giverCountAndTimeRemaining}>
                                {!project.refunded_at && (
                                    <div>
                                        <span className={styles.givers}>{formatNumber(project.giver_count)}</span>{' '}
                                        {pluralize(project.giver_count, texts[DONOR_TEXT_KEY], texts[DONORS_TEXT_KEY])}
                                        ,&nbsp;
                                    </div>
                                )}
                                <RemainingTime showDateTimeWithGeneralText />
                            </Title>
                        </div>
                    </ThemeContainer>
                    {birthdayProject && <Image className={styles.birthdayImage} src={'causes/birthday-package.svg'} />}
                </div>
                <div className={styles.topSection}>
                    <ProjectProgress />
                    <ProjectOwnerAndReceiver />
                    <NumberOfRecentTransactions isDesktopView={true} />
                </div>
            </ThemeContainer>

            {showSupportButtons && <ProjectSupportButtons projectShareModalRef={projectShareModalRef} />}
        </div>
    );
};

export default ProjectInfoBox;
